module.exports = __webpack_public_path__ + "static/media/dark-hide-betslips.c4776628.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dark-hide-betslips.svg
// module id = 2373
// module chunks = 7